/**
 * Optimizer Control Center — global kill-switch banner
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { ShieldAlert } from 'lucide-react';

export const OptimizerKillSwitchBanner: FC = () => (
  <div
    role="alert"
    className="flex items-center gap-3 rounded-lg border border-destructive/40 bg-destructive/10 px-4 py-3 text-sm text-destructive"
  >
    <ShieldAlert className="h-5 w-5 shrink-0" />
    <div>
      <p className="font-semibold">All optimizer pushes are disabled</p>
      <p className="text-destructive/80">
        The global kill switch (FLOW_OPTIMIZER_DISABLED) is active — schedulers and
        manual updates will not push weights until it is lifted.
      </p>
    </div>
  </div>
);
